import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {RefusDemontageRealisationForm} from "./components/RefusDemontageRealisationForm";

const RefusDemontageRealisationModal = ({show, demandeDemontageId, checkedPieces, setCheckedPieces, showModal, data, setData, vehiculeId}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Refus du démontage d'une certaine pièce
            </h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <RefusDemontageRealisationForm
            demandeDemontageId={demandeDemontageId}
            checkedPieces={checkedPieces}
            setCheckedPieces={setCheckedPieces}
            showModalProp={showModal}
            data={data}
            setData={setData}
            vehiculeId={vehiculeId}
          />
        </div>
      </Modal>
    </>
  )
}

export {RefusDemontageRealisationModal}
